import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { CropService, Crop } from "../services/crop.service";
import { RequestPurposeService, RequestPurpose, RequestPurposeType } from "../services/request-purpose.service";
import { RequestStatusService, RequestStatus, RequestStatusEnum } from "../services/request-status.service";
import { UserService, User } from "../services/user.service";

@Injectable()
export class ViewRequestsResolver implements Resolve<ViewRequestOptions> {
  constructor(
      private cropService: CropService,
      private requestPurposeService: RequestPurposeService,
      private requestStatusService: RequestStatusService,
      private userService: UserService) {}

  resolve(_route: ActivatedRouteSnapshot): Observable<ViewRequestOptions> {
    return Observable
      .forkJoin(
        this.cropService.getAll(),
        this.userService.getAll(),
        this.requestPurposeService.getAll(),
        this.requestStatusService.getAll()
      ).map((
        [
          crops,
          users,
          requestPurposes,
          requestStatuses
        ]) =>
        {
            const orderedRequestStatusIds = [
              RequestStatusEnum.Draft,
              RequestStatusEnum.Submitted,
              RequestStatusEnum.Assigned,
              RequestStatusEnum.ReadyForReview,
              RequestStatusEnum.Reviewed,
              RequestStatusEnum.CreatingExperiment,
              RequestStatusEnum.ExperimentCreationError,
              RequestStatusEnum.ExperimentInProgress,
              RequestStatusEnum.Pollination,
              RequestStatusEnum.Harvest,
              RequestStatusEnum.Cancelled,
              RequestStatusEnum.None,
              RequestStatusEnum.ExperimentCompleted
            ];

            const orderedRequestPurposeIds = [
              RequestPurposeType.BiomassInFlats,
              RequestPurposeType.BiomassInPots,
              RequestPurposeType.PollinationAndImmatureHarvest,
              RequestPurposeType.PollinationAndMatureHarvest,
              RequestPurposeType.Donors
            ];

            const orderedRequestStatuses = requestStatuses.sort((r1, r2) => {
              const r1Index = orderedRequestStatusIds.findIndex(or => or === <RequestStatusEnum> r1.id);
              const r2Index = orderedRequestStatusIds.findIndex(or => or === <RequestStatusEnum> r2.id);

              return r1Index - r2Index;
            });

            const orderedRequestPurposes = requestPurposes.sort((r1, r2) => {
              const r1Index = orderedRequestPurposeIds.findIndex(or => or === <RequestPurposeType> r1.id);
              const r2Index = orderedRequestPurposeIds.findIndex(or => or === <RequestPurposeType> r2.id);

              return r1Index - r2Index;
            });
            const cropDictionary = this.createDictionary<Crop>(crops, "id");
            const userDictionary = this.createDictionary<User>(users, "id");
            const requestPurposeDictionary = this.createDictionary<RequestPurpose>(requestPurposes, "id");
            const requestStatusDitionary = this.createDictionary<RequestStatus>(requestStatuses, "id");

            return <ViewRequestOptions> {
              requestStatuses: orderedRequestStatuses,
              requestPurposes: orderedRequestPurposes,
              cropDictionary,
              userDictionary,
              requestPurposeDictionary,
              requestStatusDitionary
            };
        }
      );
  }

  private createDictionary<T>(array: Array<T>, indexKey: keyof T): { [key: string]: T } {
    const dictionary: any = {};
    for (let i = 0; i < array.length; i++) {
         const key = array[i][indexKey];
         dictionary[key] = array[i];
    }
    return dictionary as { [key: string]: T };
  }
}

export interface ViewRequestOptions {
  requestStatuses: RequestStatus[];
  requestPurposes: RequestPurpose[];
  cropDictionary: { [key: string]: Crop };
  userDictionary: { [key: string]: User };
  requestPurposeDictionary: { [key: string]: RequestPurpose };
  requestStatusDitionary: { [key: string]: RequestStatus };
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/resolvers/view-requests.resolver.ts